<script>
	import Game from "./game/Game.svelte";
	import Button from "../components/Button.svelte";
	import TextField from "../components/TextField.svelte";
	import Toasts from "../components/toasts/Toasts.svelte";

	import { crate } from "../wasm.js";
	const { Engine } = crate;

	let fenString = "";

	let engine = undefined;

	function handleStartGame() {
		if (fenString.length > 0) {
			engine = Engine.from_fen(fenString);
		} else {
			engine = Engine.initial();
		}
	}
</script>

<Toasts position="top-right">
	<div class="root centered">
		{#if engine}
			<Game bind:engine />
		{:else}
			<div class="game-params-container vstack">
				<div class="title">WebAssembly Chess</div>
				<div class="separator" />
				<div class="game-params vstack">
					<TextField
						label="Initial FEN String"
						placeholder="Leave empty for normal game"
						bind:value={fenString}
					/>
					<Button label="Start Game" on:click={handleStartGame} />
				</div>
			</div>
		{/if}
	</div>
</Toasts>

<style>
	.root {
		width: 100%;
		height: 100%;
	}

	.game-params-container {
		gap: 20px;
	}

	.game-params {
		gap: 5px;
	}

	.title {
		font-size: 30px;
		font-weight: bold;
		text-align: center;
	}

	.separator {
		width: 100%;
		height: 2px;
		background-color: var(--fg-color);
	}
</style>
